module.exports = __webpack_public_path__ + "static/media/mexican-standoff-animation.51cfb5e3.svg";